export default __webpack_public_path__ + "images/f0dfdb49a65ec0e0da7c8b11c594e2c2-1_4K_1920x544.webp";